import Vue from 'vue'
import VueRouter from 'vue-router'

//Auth
//Login
import Login from '../views/admin/auth/login/Index.vue'

//Admin
//Base
import AdminBase from '../views/admin/Base.vue'
//Dashboard
import Dashboard from '../views/admin/Dashboard.vue'
//Paages
import OnlineApplication from '../views/admin/pages/Online-Application.vue'
import Testimonial from '../views/admin/pages/Testimonial.vue'
import WebsiteInfo from '../views/admin/pages/Website-Info.vue'
import About from '../views/admin/pages/About.vue'
import Course from '../views/admin/pages/Course.vue'
import Events from '../views/admin/pages/Events.vue'
import Banner_Images from '../views/admin/pages/Banner-Images.vue'
import Index from '../views/admin/pages/Index.vue'
import SpecialProgram from '../views/admin/pages/Special-Program.vue'

//User
import UserRole from '../views/admin/pages/user/User-Role.vue'
import Permission from '../views/admin/pages/user/User-Rights.vue'
import Users from '../views/admin/pages/user/User.vue'

//Change Password
import changePassword from '../views/admin/auth/Change-Password.vue'

//Error Page
import errorPage404 from '../views/admin/pages/404.vue'


Vue.use(VueRouter)

  const routes = [
    {
    path: '/',
    name: 'home',
    // redirect: '/login'
    component: Index
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/404',
    component: errorPage404
  },
  {
    path: '*',
    component: errorPage404
  },
  {
    path: '/AdminBase',
    name: 'AdminBase',
    component: AdminBase,
    beforeEnter: function(to, from, next) {
      if(localStorage.getItem('token')){
        next();
      }
      else {
        next('/login');
      }
    },
    children: [
      {
        path: '/admin/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta:{
          activeNum: "1",
          title: "Dashboard"
        },
        redirect: '/admin/online-application'
      },
      {
        path: '/admin/online-application',
        name: 'OnlineApplication',
        component: OnlineApplication,
        meta:{
          activeNum: "2",
          title: "Online Application"
        }
      },
      {
        path: '/admin/testimonial',
        name: 'Testimonial',
        component: Testimonial,
        meta:{
          activeNum: "3",
          title: "Testimonial"
        }
      },
      {
        path: '/admin/website-Info',
        name: 'WebsiteInfo',
        component: WebsiteInfo,
        meta:{
          activeNum: "4",
          title: "Website Info"
        }
      },
      {
        path: '/admin/about',
        name: 'About',
        component: About,
        meta:{
          activeNum: "5",
          title: "About"
        }
      },
      {
        path: '/admin/user-role',
        name: 'UserRole',
        component: UserRole,
        meta:{
          activeNum: "6-1",
          title: "User Role"
        }
      },
      {
        path: '/admin/permission',
        name: 'Permission',
        component: Permission,
        meta:{
          activeNum: "6-2",
          title: "Permission"
        }
      },
      {
        path: '/admin/users',
        name: 'Users',
        component: Users,
        meta:{
          activeNum: "6-3",
          title: "Users"
        }
      },
      {
        path: '/admin/course',
        name: 'Course',
        component: Course,
        meta:{
          activeNum: "7",
          title: "Course"
        }
      },
      {
        path: '/admin/events',
        name: 'Events',
        component: Events,
        meta:{
          activeNum: "8",
          title: "Events"
        }
      },
      {
        path: '/admin/banner-images',
        name: 'Banner_images',
        component: Banner_Images,
        meta:{
          activeNum: "9",
          title: "Banner Images"
        }
      },
      {
        path: '/admin/changePassword',
        name: 'changePassword',
        component: changePassword,
        meta:{
          activeNum: "10",
          title: "Change Password"
        }
      },
      {
        path: '/admin/special-program',
        name: 'SpecialProgram',
        component: SpecialProgram,
        meta:{
          activeNum: "11",
          title: "Special Program"
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
